
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"200","height":"200","viewBox":"0 0 52.917 52.917","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.543 7.277c-10.617 0-19.266 8.648-19.266 19.266 0 10.617 8.648 19.268 19.266 19.268 10.482 0 19.012-8.441 19.229-18.873v-.004a1.984 1.984 0 00.039-.39 1.984 1.984 0 00-.04-.393c-.215-10.433-8.745-18.873-19.228-18.873zm0 3.968c8.472 0 15.299 6.825 15.299 15.297s-6.827 15.3-15.3 15.3-15.296-6.827-15.296-15.3 6.824-15.297 15.297-15.297z"}}),_c('path',{attrs:{"d":"M24.576 23.308h3.936v13.206h-3.936zm-.558-4.375c0-.634.23-1.18.689-1.64.48-.48 1.082-.721 1.804-.721s1.323.23 1.804.689c.503.437.754.995.754 1.672s-.251 1.247-.754 1.706c-.481.437-1.083.656-1.804.656s-1.323-.23-1.804-.689c-.46-.48-.689-1.038-.689-1.673z"}})])
          )
        }
      }
    